// extracted by mini-css-extract-plugin
module.exports = {"singleImage":"hover-image_singleImage__2HZ6d","hoverImage":"hover-image_hoverImage__fZ_mq","buttonWrapper":"hover-image_buttonWrapper__lzro7","active":"hover-image_active__231BO"};